//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.FloorPlanTicketType

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The seats pricing model
* 
* @param category the category id (categoryKey)
* @param ticketTypes the ticket types
*/
@Serializable

data class FloorPlanPricing (


      /* the category id (categoryKey) */
    @SerialName(value = "category") val category: kotlin.Int? = null,


      /* the ticket types */
    @SerialName(value = "ticketTypes") val ticketTypes: kotlin.collections.List<FloorPlanTicketType>? = null


) {




  }

